import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { addLearner, updateLearner, addCohortLearner, updateCohortLearner } from '../../services/SuperAdminLearnerService';
import { toast } from 'react-toastify';
import { getCountryList, validatePassword, getAllCountryData, getAllStatesData, getAllCitiesData } from '../../services/CommonService';
import Select from 'react-select';
import { getAllCohorts } from '../../services/SuperAdminCohortService';
import Loader from '../../utility/Loader';

export default function SuperAdminCreateLearner() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    const [user, setUser] = useState({first_name: "", middle_name: "", last_name: "", email: "", password: "", status: "ACTIVE", role: "LEARNER", state: "", city: "", country: "USA", addr_line1: "", addr_line2: "", zip_code: "", phone_no: "", expiry_date: ""});
    const [countriesList, setCountriesList] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [countryCode, setCountryCode] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [edit, setEdit] = useState(false);
    const [cohorts, setCohorts] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedCohort, setSelectedCohort] = useState(0);
    const [returnToCohort, setReturnToCohort] = useState(false);
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
            navigate('/login');
        }else{

            setUserDetails(userDetails);

            let selectedCust = sessionStorage.getItem('selectedCustomer') === null ? null : JSON.parse(sessionStorage.getItem('selectedCustomer'));
            let selectedChs = sessionStorage.getItem('addLearnersInCohort') === null ? null : JSON.parse(sessionStorage.getItem('addLearnersInCohort'));
            if(selectedChs !== null){
                setReturnToCohort(true);
                selectedCust = selectedChs;
                sessionStorage.removeItem('addLearnersInCohort');
            }

            if(selectedCust === null){
                toast.warn("Please select a customer in manage learner page!");
                navigate('/superadmin/managelearners')
            }else{
                setSelectedCustomer(selectedCust);
                let selectedLearner = sessionStorage.getItem('selectedLearner') === null ? null : JSON.parse(sessionStorage.getItem('selectedLearner'));
                if(selectedLearner === null){
                    setEdit(false);
                    if(selectedChs !== null){
                        if(selectedCust !== null && selectedCust !== undefined && selectedCust.id !== undefined){
                            setUser({first_name: "", middle_name: "", last_name: "", email: "", password: "", status: "ACTIVE", role: "LEARNER", state: "", city: "", country: "USA", addr_line1: "", addr_line2: "", zip_code: "", phone_no: "", customer_id: selectedCust.id, cohort_id: selectedCust.cohort_id, expiry_date: ""});
                        }
                        setSelectedCohort(selectedChs.cohort_id);
                    }else{
                        if(selectedCust !== null && selectedCust !== undefined && selectedCust.id !== undefined){
                            setUser({first_name: "", middle_name: "", last_name: "", email: "", password: "", status: "ACTIVE", role: "LEARNER", state: "", city: "", country: "USA", addr_line1: "", addr_line2: "", zip_code: "", phone_no: "", customer_id: selectedCust.id, expiry_date: ""});
                        }
                    }
                }
                else{
                    setEdit(true);
                    setSelectedCohort(selectedLearner.cohort_id);
                    if(selectedCust !== null && selectedCust !== undefined && selectedCust.id !== undefined){
                        setUser({
                            ...selectedLearner,
                            ["customer_id"]: selectedCust.id
                        });
                    }
                }
                sessionStorage.removeItem('selectedCustomer');
                sessionStorage.removeItem('selectedLearner');

                getAllData(selectedCust, selectedLearner);
            }

        }
    },[]);

    const getAllData = async (selectedCust, selectedLearner) => {
        setLoading(true);
        await getCountries(selectedLearner);
        const userDtl = getUserDetails();
        await getCohorts(selectedCust.id, userDtl.token);
        setLoading(false);

    };

    const getCohorts = async (customer_id, token) => {
        const cohortsData = await getAllCohorts(customer_id, token);
        if(cohortsData.error){
            return [];
        }else{
            let ch = [];
            for(let i=0;i<cohortsData.data.length; i++){
                let chObj = {value: cohortsData.data[i].cohort_id, label: cohortsData.data[i].cohort_desc + " - "+ (cohortsData.data[i].org_name !== null && cohortsData.data[i].org_name !== undefined ? cohortsData.data[i].org_name : "")};
                ch.push(chObj);
            }
            setCohorts(ch);
        }
    };

    const getCountries = async (selectedLearner) => {
        const userDetails = getUserDetails();
        if(userDetails.token !== undefined){
            setLoading(true);
            const response = await getAllCountryData(userDetails.token);
            const countryList = response.data;
            setCountriesList(countryList);
            let cntry = [];
            let cntryCode = {};
            for(let i=0; i<countryList.length; i++){
                cntry.push({label: countryList[i].country, value: countryList[i].country});

                cntryCode[countryList[i].country] = countryList[i].phone_cd
            }
            setCountries(cntry);
            setCountryCode(cntryCode);
            if(selectedLearner !== null && selectedLearner.country !== null && selectedLearner.country !== undefined){
                await changeCountryValue("country", selectedLearner.country, countryList);
                if(selectedLearner.state !== undefined && selectedLearner.state !== '' && selectedLearner.state !== null){
                    await changeCountryValue("state", selectedLearner.state, countryList);
                }
            }else{
                await changeCountryValue("country", user.country, countryList);
                
            }
            setLoading(false);

        }else{
            toast.info("Please login again");
            navigate('/login');
        }
    };

    const handleCohortValueChange = async (value) => {
        setUser({
            ...user,
            ["cohort_id"]: value
        });
    };

    const handleCountryValueChange = async (name, value) => {

        if(name === 'country'){
            setUser({
                ...user,
                ["state"]: undefined,
                [name]: value,
                ["city"]: undefined
            });  
        } else if(name === 'state'){
            setUser({
                ...user,
                [name]: value,
                ["city"]: undefined
            });  
            
        }else{
            setUser({
                ...user,
                [name]: value
            });
        }
        await changeCountryValue(name, value, countriesList);
    };

    const changeCountryValue = async (name, value, countryList) => {
        const userDetails = getUserDetails();
        if(name === 'country'){
            let values = [];
            const st = await getAllStatesData(userDetails.token, value);
            
            for(let i=0; i<st.data.length; i++){
                values.push({label: st.data[i].state, value: st.data[i].state}); 
            }
            setStates(values);
        }
        if(name === 'state'){
            let values = [];
            const st = await getAllCitiesData(userDetails.token, value);     
            for(let i=0; i<st.data.length; i++){
                values.push({label: st.data[i].city, value: st.data[i].city}); 
            }
            setCities(values);
        }
    };

    const handleValueChange = (e) => {
        const { name, value } = e.target;
        setUser({
          ...user,
          [name]: value,
        });
    };

    const validateUser = (user) => {
        return user.email === undefined || user.email === null || user.email === ''
        || user.password === undefined || user.password === null || user.password === '' || user.cohort_id === null || user.cohort_id === undefined || user.cohort_id === '';
    };

    const addAdmin = async () => {
        const userDetails = getUserDetails();
        const isValid = validateUser(user);
        if(user.phone_no !== '' && user.phone_no !== undefined && user.phone_no !== null && user.phone_no.length > 10){
            toast.warn("Phone number length is greater than 10 digits!");
        }
        else if(user.zip_code !== '' && user.zip_code !== undefined && user.zip_code !== null && user.zip_code.length > 5){
            toast.warn("Zip Code length is greater than 5 digits!");
        }else if(!validatePassword(user.password)){
            toast.error("Password is not Valid. Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a numeral, and a special character.");
        }
        else if(!isValid){
            if(userDetails.token){
                setLoading(true);
                let resp = await addLearner(userDetails.token, user);
                setLoading(false);
                if(resp.error===false){
                    toast.success("User with role Learner is created!");
                    const insertId = resp.id;
                    let resp1 = await addCohortLearner(userDetails.token, {user_id: insertId, cohort_id: user.cohort_id, customer_id: selectedCustomer.id});
                }else{
                    toast.error(resp.data);
                }
            }else{
                    toast.info("Please login again");
                    navigate('/login');        
            }
        }else{
            toast.error("Mandatory Fields are empty");
        }
        
    };

    const updateAdmin = async () => {
        const userDetails = getUserDetails();
        const isValid = validateUser(user);
        if(user.phone_no !== '' && user.phone_no !== undefined && user.phone_no !== null && user.phone_no.length > 10){
            toast.warn("Phone number length is greater than 10 digits!");
        }
        else if(user.zip_code !== '' && user.zip_code !== undefined && user.zip_code !== null && user.zip_code.length > 5){
            toast.warn("Zip Code length is greater than 5 digits!");
        }else if(!validatePassword(user.password)){
            toast.error("Password is not Valid. Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a numeral, and a special character.");
        }
        else if(!isValid){
            if(userDetails.token){
                setLoading(true);
                let resp = await updateLearner(userDetails.token, user);
                setLoading(false);
                if(resp.error===false){
                    toast.success("Changes updated successfully!");
                    if(user.cohort_learner_id !== null){
                        if(parseInt(selectedCohort) !== parseInt(user.cohort_id)){
                            let resp1 = await updateCohortLearner(userDetails.token, {user_id: user.id, cohort_id: user.cohort_id, id: user.cohort_learner_id, status: user.status, customer_id: selectedCustomer.id});
                        }
                    }else{
                        const insertId = resp.id;
                        let resp1 = await addCohortLearner(userDetails.token, {user_id: user.id, cohort_id: user.cohort_id, customer_id: selectedCustomer.id});
                    }
                }else{
                    toast.error(resp.data);
                }
              }else{
                    toast.info("Please login again");
                    navigate('/login');        
              }
        }else{
            toast.error("Mandatory Fields are empty");
        }
        
    };

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className=''>
                    <h3 className='text-2xl text-secondary inter-700 mt-6 lg:mt-0 mb-6 md:mb-4 lg:mb-3 lg:hidden'>Add New Learner</h3>
                    <form className='w-full lg:w-full xl:w-full'>
                        <div className='pt-10 lg:px-12 px-6 pb-4 bg-[#FDF8F8] border-b border-[#D9D9D9]'>
                            <div className='back-btn flex justify-start mb-5 md:mb-8'>
                                <a onClick={() => navigate(returnToCohort ? '/superadmin/managecohort': '/superadmin/managelearners')} className='cursor-pointer w-auto bg-tertiary hover:bg-black flex items-center justify-center px-6 h-7 2xl:h-8 text-white inter-500 text-xs 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Back</a>
                            </div>
                            <h4 className='text-lg text-secondary inter-400 mb-0 md:mb-0'>Customer</h4>
                            <h4 className='text-xl text-secondary inter-700 mb-4 md:mb-8'>{selectedCustomer === null ? "" : selectedCustomer.name}</h4>
                        </div>
                        <div className='lg:py-10 lg:px-12 py-6 px-6 w-full lg:w-4/5'>
                            <div className='flex justify-between flex-wrap'>
                                <div className='form-field w-full md:w-[65%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Cohort <span className='text-[#f00]'>*</span></label>
                                    <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                        options={cohorts}
                                        value={cohorts.find(option => option.value === user.cohort_id)}
                                        onChange={(values) => handleCohortValueChange(values.value)}
                                    />
                                </div>
                            </div>

                            <div className='flex justify-between flex-wrap'>
                                <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>First Name <span className='text-[#f00]'>*</span></label>
                                    <input type='text' name="first_name" value={user.first_name} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                </div>
                                <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Middle Name</label>
                                    <input type='text' name="middle_name" value={user.middle_name} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                </div>
                                <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Last Name <span className='text-[#f00]'>*</span></label>
                                    <input type='text' name="last_name" value={user.last_name} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                </div>
                            </div>
                            <div className='w-full md:w-4/5'>
                                <div className='flex justify-between flex-wrap'>
                                    <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Email <span className='text-[#f00]'>*</span></label>
                                        <input type='email' name="email" value={user.email} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                    </div>
                                    <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Password <span className='text-[#f00]'>*</span></label>
                                        <div className='relative'>   
                                            {edit ? (
                                            <input type={showPassword ? 'text' : 'password'} name="password" value={user.password} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required disabled/>

                                            ) : (
                                                <>
                                            <input type={showPassword ? 'text' : 'password'} name="password" value={user.password} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                            <button onClick={() => handleShowPassword()} type='button' className='absolute right-4 top-0 h-full w-5 flex items-center justify-center'>
                                                <img className={showPassword ? 'pass-view-btn' : 'pass-hide-btn opacity-50'} src={showPassword ? '../images/pass-view.webp' : '../images/pass-hide.webp'} alt='password hide'/>
                                            </button>
                                            </>
                                            )}

                                        </div>
                                    </div>
                                </div>

                                <div className='flex justify-between flex-wrap'>
                                    <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Country </label>
                                        <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                            options={countries}
                                            value={countries.find(option => option.value === user.country)}
                                            onChange={(values) => handleCountryValueChange("country", values.value)}
                                        />
                                    </div>
                                    {/* <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Phone <span className='text-[#f00]'>*</span></label>
                                        <div className='relative'>
                                            <input type='number' name="phone_no" value={user.phone_no} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 pr-6 pl-16  2xl:pr-10 transition duration-300' required/>
                                            <div className='absolute left-0 top-0 w-14'>
                                                <input type='text' name="country_code" value={countryCode[user.country]} onChange={handleValueChange} placeholder='' className='inter-400 bg-transparent text-black text-base border-r border-[#bbb] focus:border-[#B44D71] text-center h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-2 transition duration-300 inline-block' required disabled/>
                                            </div>
                                        </div>  
                                    </div> */}
                                </div>
                                <div>
                                    <div className='form-field w-full mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>State </label>
                                        <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                            options={states}
                                            value={states.find(option => option.value === user.state)}
                                            onChange={(values) => handleCountryValueChange("state", values.value)}
                                        />
                                    </div>
                                    <div className='form-field w-full mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>City </label>
                                        <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                            options={cities}
                                            value={cities.find(option => option.value === user.city)}
                                            onChange={(values) => handleCountryValueChange("city", values.value)}
                                        />
                                    </div>
                                    {/* <div className='form-field w-full mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Address 01 <span className='text-[#f00]'>*</span></label>
                                        <input type='text' name="addr_line1" value={user.addr_line1} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                    </div>
                                    <div className='form-field w-full mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Address 02 </label>
                                        <input type='text' name="addr_line2" value={user.addr_line2} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                    </div>  */}
                                    <div className='form-field w-full mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Zip Code </label>
                                        <input type='number' name="zip_code" value={user.zip_code} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                    </div>
                                    <div className='flex justify-between flex-wrap'>
                                        <div className='form-field w-full mb-5 md:mb-8'>
                                            <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Expiry Date</label>
                                            <input type='date' name="expiry_date" value={user.expiry_date} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300'/>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='customer-radio-sngl w-full md:w-max mr-5 md:mr-8 mb-5 md:mb-8'>
                                            <input type="radio" id="suspended" name="status" onChange={handleValueChange} value='SUSPENDED' checked={user.status === "SUSPENDED"} />
                                            <label htmlFor="suspended">Suspended</label>
                                        </div>
                                        <div className='customer-radio-sngl w-full md:w-max mr-5 md:mr-8 mb-5 md:mb-8'>
                                            <input type="radio" id="active" name="status" onChange={handleValueChange} value='ACTIVE' checked={user.status === "ACTIVE"} />
                                            <label htmlFor="active">Active</label>
                                        </div>
                                        <div className='customer-radio-sngl w-full md:w-max mr-5 md:mr-8 mb-5 md:mb-8'>
                                            <input type="radio" id="cancelled" name="status" onChange={handleValueChange} value='CANCELLED' checked={user.status === "CANCELLED"} />
                                            <label htmlFor="cancelled">Cancelled</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='flex text-center items-center mt-6 2xl:mt-10'>
                                {edit ? (
                                    <button onClick={() => updateAdmin()} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>+ Update Changes</button>

                                ) : (
                                    <button onClick={() => addAdmin()} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>+ Add Learner</button>
                                )}
                            </div>
                        </div>
                    </form>

                </div>
            )}
        </div>
    );
}